// extracted by mini-css-extract-plugin
module.exports = {"doughnut":"ChartEnergyBill_doughnut__2A_UI"};